export function camelize(string: string) {
  return string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, character) => character.toUpperCase());
}
